import React, { useEffect, useState } from 'react'
import axios from 'axios'
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Typography,
  Tooltip,
  Avatar,
  useMediaQuery,
} from '@mui/material'
import {
  AccountTreeOutlined as AccountTreeOutlinedIcon,
  SummarizeOutlined as SummarizeOutlinedIcon,
} from '@mui/icons-material/'
import { toast } from 'react-toastify'
import { AddOutlined as AddOutlinedIcon } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'
import { blue } from '@mui/material/colors'
import { useNavigate } from 'react-router-dom'
import ConfirmationBox from './ConfirmationBox'
import { REDIRECT_TIMER, TOAST_SETTINGS, TOAST_SETTINGS_ERROR } from '../../utility/constants'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useResponsiveTypography } from '../../utility/responsiveTypography'

const useStyles = makeStyles({
  avatar: {
    backgroundColor: () => {
      /*if (note.category == "work") {
        return yellow[700];
      }
      if (note.category == "money") {
        return green[500];
      }
      if (note.category == "todos") {
        return pink[500];
      }*/
      return blue[500]
    },
  },
})

export default function ProcessTemplateCard({
  processTemplate,
  allowViewProcess,
  allowIntiateProcess,
}) {
  const { user } = useAuthContext()
  const NODE_BASE_URL = process.env.REACT_APP_NODE_BASE_URL
  let axiosOptions = {}
  if (user) {
    axiosOptions = {
      headers: { Authorization: `Bearer ${user.token}` },
    }
  }
  const classes = useStyles()
  const navigate = useNavigate()
  const [isCreateNewProcessButtonDisabled, setIsCreateNewProcessButtonDisabled] = useState()

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const { title, subtitle, cardIcons, cardtitle, cardsubtitle, cardSubtitle } =
    useResponsiveTypography()
  const handleCreateNewProcess = async () => {
    setIsDialogOpen(false)
    setIsCreateNewProcessButtonDisabled(true)
    const toastErrorMsg = 'An error occured while initiating the new process.'
    const toastSuccessMsg = 'New process initiated successfully.'
    try {
      const { process_id, activity_template_id } = (
        await axios.post(
          `${NODE_BASE_URL}/data-entry/process-data`,
          { process_template_id: processTemplate.id },
          axiosOptions
        )
      ).data

      toast.success(toastSuccessMsg, TOAST_SETTINGS)
      setTimeout(
        () => navigate(`/process-data/${process_id}/${activity_template_id}`),
        REDIRECT_TIMER
      )
    } catch (err) {
      toast.error(toastErrorMsg, TOAST_SETTINGS_ERROR)
      setIsCreateNewProcessButtonDisabled(false)
    }
  }

  const openDialog = () => {
    setIsDialogOpen(true)
  }

  return (
    <Card
      elevation={1}
      style={{
        boxShadow: 'none',
        overflow: 'visible',
      }}
      sx={{
        ':hover': {
          boxShadow: '0px',
        },
        borderRadius: '0px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className="process-card-header">
          <CardHeader
            sx={{ padding: '5px 8px' }}
            avatar={
              <Avatar
                className={classes.avatar}
                size="small"
                sx={{
                  bgcolor: processTemplate.color_code,
                  width: '30px',
                  height: '30px',
                  fontSize: '14px',
                  fontWeight: '600',
                }}
              >
                {processTemplate.process_template_name[0].toUpperCase()}
              </Avatar>
            }
            title={
              <Typography
                style={{
                  fontSize: cardtitle,
                  color: '#27104E',
                  fontWeight: '600',
                  marginBottom: '3px',
                }}
              >
                {processTemplate.process_template_name}
              </Typography>
            }
            subheader={
              <Typography
                style={{
                  fontSize: cardSubtitle,
                  color: '#4B4F60',
                  fontWeight: '500',
                }}
              >
                {processTemplate.prefix}
              </Typography>
            }
          />
        </div>
        <div className="mt-0 mx-2 ">
          {
            <div style={cardIcons}>
              {allowIntiateProcess && (
                <Tooltip title={`Initiate new ${processTemplate.process_template_name}`}>
                  <IconButton
                    sx={{ padding: '5px' }}
                    disabled={isCreateNewProcessButtonDisabled}
                    onClick={openDialog}
                    size="small"
                  >
                    <AddOutlinedIcon color="info" sx={{ fontSize: '16px' }} />
                  </IconButton>
                </Tooltip>
              )}
              {allowViewProcess && (
                <>
                  {/* <Tooltip title="Report">
                    <IconButton
                      onClick={() =>
                        navigate(
                          `/process-dashboard/${processTemplate.id}/report`
                        )
                      }
                      size="small"
                    >
                      <SummarizeOutlinedIcon color="info" />
                    </IconButton>
                  </Tooltip> */}
                  <Tooltip title="View process data">
                    <IconButton
                      onClick={() => navigate(`/process-dashboard/${processTemplate.id}`)}
                      size="small"
                    >
                      <AccountTreeOutlinedIcon
                        color="info"
                        sx={{ fontSize: '16px', marginRight: '1px', marginBottom: '3px' }}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </div>
          }
        </div>

        {/* <div className="process-card-content"> */}
        {/* <CardContent> */}
        {/* <Typography */}
        {/* variant="body2" */}
        {/* style={{ */}
        {/* fontSize: subtitle, */}
        {/* color: '#27104E', */}
        {/* fontWeight: '600', */}
        {/* fontSize: '13px', */}
        {/* padding: '0px 5px', */}
        {/* }} */}
        {/* color="textSecondary" */}
        {/* > */}
        {/* {processTemplate.description} */}
        {/* </Typography> */}
        {/* </CardContent> */}
        {/* </div> */}

        {isDialogOpen && (
          <ConfirmationBox
            title={`Are you sure you want to create a new ${processTemplate.process_template_name}`}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            onYes={handleCreateNewProcess}
          />
        )}
      </div>
      <div className="card-description mb-1">
        <Typography
          className="text-ellipsis"
          style={{
            fontSize: cardSubtitle,
            color: '#656D92',
            fontWeight: '500',
            lineHeight: 1.2,
            padding: '0px 10px',
          }}
        >
          {processTemplate.description}
        </Typography>
      </div>
    </Card>
  )
}
